
export type UpdateNotificationSettingsBodyFrequency = typeof UpdateNotificationSettingsBodyFrequency[keyof typeof UpdateNotificationSettingsBodyFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNotificationSettingsBodyFrequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;
